import { render, staticRenderFns } from "./lafia_castle.vue?vue&type=template&id=1174e392&scoped=true"
import script from "./lafia_castle.vue?vue&type=script&lang=js"
export * from "./lafia_castle.vue?vue&type=script&lang=js"
import style0 from "./lafia_castle.vue?vue&type=style&index=0&id=1174e392&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../ct-id-20261026/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1174e392",
  null
  
)

export default component.exports